// frontend/src/index.js
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { I18nextProvider } from "react-i18next";
import i18n from "@shared/i18n"; // ✅ points to packages/shared-i18n/src/index.js

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18n}>
    <Suspense fallback={<div>LOADING...</div>}>
      <App />
    </Suspense>
  </I18nextProvider>
);
